import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { TierBadge } from "@/components/TierBadge";
import { Link } from "react-router-dom";
import { toast } from "sonner";

const STAGES = ["Approved", "Paused"];

export default function Onboarding() {
  const [list, setList] = useState([]);

  const load = () => api.get("/affiliates").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const move = async (id, stage) => {
    try {
      await api.patch(`/affiliates/${id}`, { onboarding_stage: stage });
      toast.success(`Moved to ${stage}`);
      load();
    } catch { toast.error("Failed"); }
  };

  const byStage = STAGES.reduce((acc, s) => { acc[s] = list.filter((a) => a.onboarding_stage === s); return acc; }, {});

  const onDragStart = (e, id) => e.dataTransfer.setData("id", id);
  const onDrop = (e, stage) => { e.preventDefault(); const id = e.dataTransfer.getData("id"); if (id) move(id, stage); };
  const onDragOver = (e) => e.preventDefault();

  return (
    <div>
      <PageHeader title="Affiliate Status" subtitle="Approve or pause affiliates. Drag between columns." />
      <div className="p-6 md:p-10">
        <div className="flex gap-4 overflow-x-auto no-scrollbar pb-4">
          {STAGES.map((stage) => (
            <div
              key={stage}
              data-testid={`kanban-col-${stage.replace(/\s/g, "-").toLowerCase()}`}
              onDrop={(e) => onDrop(e, stage)}
              onDragOver={onDragOver}
              className="min-w-[280px] w-72 rounded-3xl bg-secondary/40 border border-border/40 p-4 flex flex-col gap-3"
            >
              <div className="flex items-center justify-between px-2">
                <div className="text-sm font-semibold">{stage}</div>
                <div className="text-xs font-semibold rounded-full bg-background px-2 py-0.5">{byStage[stage].length}</div>
              </div>
              {byStage[stage].map((a) => (
                <div
                  key={a.id}
                  draggable
                  onDragStart={(e) => onDragStart(e, a.id)}
                  data-testid={`kanban-card-${a.id}`}
                  className="rounded-2xl border border-border/60 bg-card p-4 cursor-grab hover:shadow-md transition-shadow"
                >
                  <Link to={`/affiliates/${a.id}`} className="flex items-center gap-3">
                    {a.avatar_url ? (
                      <img src={a.avatar_url} alt="" className="h-9 w-9 rounded-full object-cover" />
                    ) : (
                      <div className="h-9 w-9 rounded-full bg-secondary flex items-center justify-center text-sm font-semibold">{a.name.charAt(0)}</div>
                    )}
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-semibold truncate">{a.name}</div>
                      <div className="text-xs text-muted-foreground truncate">{a.niche || a.city || "—"}</div>
                    </div>
                  </Link>
                  <div className="mt-2 flex items-center justify-between">
                    <TierBadge tier={a.tier} />
                    <span className="text-[10px] text-muted-foreground">{a.instagram || ""}</span>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
